const ResultSet = {
  subtitle: {
    English: "Here's what you're doing well:",
    German: "Hier sehen Sie, was bei Ihnen gut läuft:",
    French: "Vos points forts :",
    Turkish: "İyi yaptığınız şeyler:",
    Italian: "Ecco in cosa stai andando bene:",
    Espanol: "Esto es lo que está haciendo bien:",
  },
  titleG: {
    English: "Here's how your business is doing",
    German: "Sie stehen auf einer Stufe mit den besten Finanzorganisationen:",
    French:
      "Vous êtes au niveau des services financiers les plus performants :",
    Turkish: "En iyi finans kuruluşlarıyla başa baş gidiyorsunuz:",
    Italian:
      "Sei al passo con le migliori organizzazioni di amministrazione, finanza e controllo.",
    Espanol: "Está a la par de las mejores empresas financieras:",
  },
  titleM: {
    English: "Here's how your business is doing",
    German: "Hier sehen Sie, was bei Ihnen gut läuft:",
    French: "Vos points forts :",
    Turkish: "İyi yaptığınız şeyler:",
    Italian: "Ecco in cosa stai andando bene:",
    Espanol: "Esto es lo que está haciendo bien:",
  },
  titleB: {
    English: "Here's how your business is doing",
    German: "Das sind die Bereiche mit Verbesserungspotenzial:",
    French: "Les points qui peuvent être améliorés :",
    Turkish: "Bazı iyileştirme fırsatları aşağıda verilmiştir:",
    Italian: "Ecco alcune opportunità di miglioramento:",
    Espanol: "Estas son algunas de las oportunidades de mejora:",
  },
  btn1: {
    English: "Discover More",
    German: "Mehr entdecken",
    French: "En savoir plus",
    Turkish: "Daha fazla keşfedin",
    Italian: "Scopri di più",
    Espanol: "Descubrir más",
  },
  btn2: {
    English: "View my score",
    German: "Link zu Ihrem Bericht",
    French: "Lien vers votre rapport",
    Turkish: "Raporunuza ulaşın",
    Italian: "Link al report",
    Espanol: "Enlace a su informe",
  },
  legend1: {
    English: "Your rating",
    German: "Ihre Bewertung",
    French: "Votre score",
    Turkish: "Puanınız",
    Italian: "Il tuo punteggio",
    Espanol: "Su puntuación",
  },
  legend2: {
    English: "Best in class",
    German: "Erstklassig",
    French: "Le meilleur du secteur",
    Turkish: "Sınıfının en iyisi",
    Italian: "Il migliore della categoria",
    Espanol: "Categoría superior",
  },
  report: {
    English: "REPORT",
    German: "BERICHT",
    French: "RAPPORT",
    Turkish: "RAPOR",
    Italian: "REPORT",
    Espanol: "INFORME",
  },
  footer1: {
    English: "Privacy/Do Not Sell My Info",
    German: "Nutzungsbedingungen und Datenschutz",
    French: "Conditions d'utilisation et confidentialité",
    Turkish: "Kullanım Koşulları Ve Gizlilik",
    Italian: "Termini d'uso e privacy",
    Espanol: "Términos de uso y privacidad",
  },
  footer2: {
    English: "Ad Choices",
    German: "Anzeigenauswahl",
    French: "Choix des publicités",
    Turkish: "Reklam Seçimleri",
    Italian: "Scelte pubblicitarie",
    Espanol: "Opciones de publicidad",
  },
  copyright: {
    English: "https://www.oracle.com/legal/privacy/",
    German: "https://www.oracle.com/de/legal/copyright.html",
    French: "https://www.oracle.com/fr/legal/copyright.html",
    Turkish: "https://www.oracle.com/tr/legal/copyright.html",
    Italian: "https://www.oracle.com/it/legal/copyright.html",
    Espanol: "https://www.oracle.com/es/legal/copyright.html",
  },
  footerLink1: {
    English: "https://www.oracle.com/legal/privacy/",
    German: "https://www.oracle.com/de/legal/privacy/",
    French: "https://www.oracle.com/fr/legal/privacy/",
    Turkish: "https://www.oracle.com/tr/legal/privacy/",
    Italian: "https://www.oracle.com/it/legal/privacy/",
    Espanol: "https://www.oracle.com/es/legal/privacy/",
  },
  footerLink2: {
    English:
      "https://www.oracle.com/legal/privacy/privacy-policy.html#advertising",
    German:
      "https://www.oracle.com/de/legal/privacy/marketing-cloud-data-cloud-privacy-policy.html#13",
    French:
      "https://www.oracle.com/fr/legal/privacy/marketing-cloud-data-cloud-privacy-policy.html#13",
    Turkish:
      "https://www.oracle.com/tr/legal/privacy/marketing-cloud-data-cloud-privacy-policy.html#13",
    Italian:
      "https://www.oracle.com/it/legal/privacy/marketing-cloud-data-cloud-privacy-policy.html#13",
    Espanol:
      "https://www.oracle.com/es/legal/privacy/marketing-cloud-data-cloud-privacy-policy.html#13",
  },
  copied: {
    English: "Copied",
    German: "Kopiert",
    French: "Copié",
    Turkish: "Kopyalandı",
    Italian: "Copiato",
  },
  cc: {
    English: "uk",
    German: "de",
    French: "fr",
    Turkish: "tr",
    Italian: "it",
    Espanol: "es",
  },
};

export default ResultSet;
